import React, { useEffect, useState,useMemo,useRef} from 'react';
import DataTable from 'components/Core/DataTable';
import Notify from 'lib/Utils/Alert';
import ReactNotificationAlert from 'react-notification-alert';
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Purchaser from 'lib/Core/Backend/Controllers/Purchaser';
import * as modalCSVcss from "../Supplier/css/modalUploadCSV.module.css";
import { ReactComponent as UploadIcon } from "../../assets/img/upload.svg";
import okIMG from "../../assets/img/ok.png";

const InvoiceManeger = ({ token, invoice }) => {
 
  const [dataTableData, setDataTableData] = useState([]);
  const [fileuploaded,setFileUploaded] = useState(false)
  const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
  const alert = React.createRef();
  const table = React.createRef();
  const [modalUploadCSV,setModalUploadCSV] = useState(false);
  const [uploadJson, setUploadJson] = useState(null);
  const toggleModalCSV = () => setModalUploadCSV(!modalUploadCSV);
  
 
  const file = useRef(null);
  const [fileCsv, setFileCsv] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {

  
    if (table.current) {
      table.current.dataTable.rows.add(invoice).draw();
    }
  }, [invoice]);

  useEffect(()=>{
    if(fileuploaded){
      if(table.current){
        
        table.current.dataTable.clear().rows.add(dataTableData).draw()
      }
    }
    
  },[dataTableData])

  

 const uploadinvoice = (row) => {
  const purchaser = row.data();
  const filenumber = purchaser.number
  setUploadJson(filenumber)
  toggleModalCSV()
   
 };

 const downloadpdf = (data,filename) =>{
  const blob = new Blob([data],);;
  const url = data;
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  };
 
 const downloadinvoice = (row) => {
  const dowpurchaser = row.data() 
  const newnumber = dowpurchaser.number
  purchaserCtl.downloadinvoice(newnumber,(data)=>{
  if (data.error || data.errorMessage) {
      Notify(alert, "danger", data.errorMessage ?? data.error);
    } else {
      Notify(alert, "success", "File download successfully");
      downloadpdf(data.downloadLink, `${newnumber}.pdf`)
     }
  })
 };

 const uploadHandler = (e) => {
  const file = e.target.files[0];
  if (file) {
    if (file.type === "text/pdf" || "application/pdf") {
      setFileCsv(file);
    } else {
      Notify(alert, "warning", "This file is not a PDF file");
    }
  }
};

const resetInfo = () => {
  setFileCsv(null);
}

const uploadFile = async () => {
  if (!fileCsv) {
    Notify(alert, 'danger', 'Please select a CSV file')
    return;
  }

  setIsProcessing(true); // set isProcessing to true when the upload starts

  purchaserCtl.uploadinvoice(fileCsv, uploadJson, data => {
    setIsProcessing(false); // set isProcessing to false when the upload completes
    setFileUploaded(true)
    if (data.error || data.errorMessage) {
      Notify(alert, "danger", data.errorMessage ?? data.error);
    } else {
      Notify(alert, "success", "File uploaded successfully");
      resetInfo();
      toggleModalCSV();
     let invoices = data.map((update) => ({...update, Uploaded: `${update.invoiceUploded}`}));
     
     
     setDataTableData(invoices);

    }
  });
}





  return (
    <>
    <div>
      <ReactNotificationAlert ref={alert} />
      <div className='table-responsive'>
      <DataTable
        ref={table}
        data={null}
        options={{
          saveState: true,
          order: [[0, 'desc']],
          
        }}
        enableSelectFilters={true}
        columns={[
          { title: 'Date', data: 'date' },
          { title: 'Number', data: 'number' },
          {title:"Type", data:"type"},
          {title:"Reference",data:'reference'},
          {title:"Currency", data: 'currency', render:(data) =>{
            if(data){
              return `${data}`
            }else{
              return ``
            }
          }
        },
          { title: 'Value', data: 'amount',
          render: (data) => {
            if(data){
              return `<span style="width: 100px" class=" text-dark">$${Number(data)?.toFixed(2).length > 5 ? Number(data)?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : Number(data).toFixed(2)}</span>`
            }
          }
          
        
        },
          { title: 'Status', data: 'status',
          
          render: (data) => {
            if (data) {
              switch (data) {
                case 1:
                  return `<span style="width: 100px" class="badge badge-pill text-white bg-info">open</span>`;
    
                case 2:
                  return `<span style="width: 100px" class="badge badge-pill text-white bg-nileBlue">in progress</span>`;
    
                case 3:
                  return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalRed">canceled</span>`;
    
                case 4:
                  return `<span style="width: 100px" class="badge badge-pill text-white bg-shamrock">completed</span>`;
                case 5:
                  return `<span style="width: 100px" class="badge badge-pill text-white bg-warning">Processing</span>`;
                case 6:
                  return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalAssColor">API Low Funds</span>`;
                case 7:
                  return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalAssColor">Non API Low Funds</span>`;
                case 8:
                  return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalOrange">Incomplete</span>`;
                case 9:
                  return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalAssColor">Api Invoice</span>`;
                case 10:
                  return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalAssColor">Non API Invoice</span>`;
                case 11:
                  return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalOrange">API Issue</span>`;
                case 12:
                  return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalOrange">CSV Mismatched</span>`;
                  case 13:
                    return `<span style="width: 100px" class="badge badge-pill text-white bg-info">Pending</span>`;
                default: return 'Error'
              }
            }
          },
        
        
        
        
        },
          {title: "Invoice", data:"number",defaultContent :"",

          render:(data, type, row)=>{
            const invoiceUplod = row.invoiceUploaded;
            const typeValue = row.type;
          
          if (invoiceUplod === true && typeValue === "Order") {
            return `
              <button class="btn text-info" data-toggle="tooltip" data-placement="top" title="Upload order file" style="padding: 5px 10px; background: transparent"><i class="fas fa-upload ncentiva-upload-purchaser"></i></button>
              <button class="btn text-info" data-toggle="tooltip" data-placement="top" title="Download Non API Order File" style="padding: 5px 10px; background: transparent"><i class="fas fa-download ncentiva-download-api-purchaser"></i></button>
             ` 
          }else if(invoiceUplod === null && typeValue === "Order"){
            return  `
             <button class="btn text-info" data-toggle="tooltip" data-placement="top" title="Upload order file" style="padding: 5px 10px; background: transparent"><i class="fas fa-upload ncentiva-upload-purchaser"></i></button>
             `
          }else if(typeValue === "Payment"){
            return `
            <button class="btn text-info" data-toggle="tooltip" data-placement="top" title="Download Non API Order File" style="padding: 5px 10px; background: transparent"><i class="fas fa-download ncentiva-download-api-purchaser"></i></button>
                 `
          }
          }
        
        
        },
        {
          title:"Uploaded",data:"invoiceUploaded",
          render:(data) =>{
              switch(data){
                case true:
                  return `<i class="fas fa-check text-success text-center"></i>`;
                  case false:
                  case null:
                    return `<i class="fas fa-file text-secondary"></i>`
              } 
          }
        }

        ]}
        
        addPurchaserBts={[
          {callback: uploadinvoice, selector: 'i.ncentiva-upload-purchaser'},
          {callback: downloadinvoice, selector: 'i.ncentiva-download-api-purchaser'},
        ]}
      />
      </div>
    </div>
    {/* <PurchaserCsvUpload modal={modalUploadCSV} toggleCSV={toggleModalCSV}  uploadJson={uploadJson} token={token} /> */}
    <Modal
        isOpen={modalUploadCSV}
        toggle={() => { toggleModalCSV(); resetInfo() }}
        backdrop="static"
        centered={true}
        size="lg"
      >
        <ModalHeader toggle={() => { toggleModalCSV(); resetInfo() }} className="custom_header_colour d-flex align-items-center justify-content-between">
          Upload PDF
        </ModalHeader>
        <ModalBody>
          <div className={modalCSVcss.container}>
            <div className="text">
              <p>Please select a file of type PDF and press send.</p>
            </div>
            <label htmlFor="file" className={modalCSVcss.formContainer}>
              <UploadIcon />
              <span>File Upload PDF</span>
              <input
                type="file"
                name=""
                id="file"
                className={modalCSVcss.dn}
                onChange={uploadHandler}
                ref={file}
                accept=".pdf"
              />
            </label>
            {fileCsv?.name && (
              <div className={modalCSVcss.fileSelected}>
                <p>
                  {fileCsv.name}{" "}
                  <span className="arrow">
                    <img src={okIMG} alt="" />
                  </span>
                </p>
              </div>
            )}
            {isProcessing && (
              <div className="d-flex align-items-center">
                <p className="mr-2 mb-0 font-weight-bold">Order is processing</p>
                <div className="spinner-border spinner-border-sm text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>

          <ModalFooter>
            <button className="btn btn-secondary" onClick={() => { toggleModalCSV(); resetInfo() }}>
              Close
            </button>
            {isProcessing ? (
              <button className="btn btn-primary" disabled>
                Send
              </button>
            ) : (
              <button className="btn btn-primary" onClick={uploadFile}>
                Send
              </button>
            )}
          </ModalFooter>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default InvoiceManeger;
